import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from '../context/AuthContext';
import ScrollToTop from '../components/ScrollToTop';
import AppRoutes from '../routes';
import usePageTracking from '../hooks/usePageTracking';
import './App.css';

function AppContent() {
  usePageTracking();

  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

function App() {

  return (
    <Router>
      <AuthProvider>
        <ScrollToTop />
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;
